// extracted by mini-css-extract-plugin
module.exports = {"container":"message_container__3JDsU","error":"message_error__3btjr","warning":"message_warning__Z4uDF","message":"message_message___GDvi","notif":"message_notif__srDDl"};